<template>
  <div class="min-max" data-comp="l-min-max">
    <slot />
  </div>
</template>

<script setup>
defineProps({
  maxWidth: {
    type: String,
    default: "auto",
  },
  minWidth: {
    type: String,
    default: "auto",
  },
  maxHeight: {
    type: String,
    default: "auto",
  },
  minHeight: {
    type: String,
    default: "auto",
  },
});
</script>

<style lang="scss" scoped>
.min-max {
  content: "";
  max-width: v-bind("maxWidth");
  min-width: v-bind("minWidth");
  max-height: v-bind("maxHeight");
  min-height: v-bind("minHeight");
}
</style>
